import { Payment } from "@omni/types/api/cart/bff/shared/payment.model";

import { PaymentMethods } from "@/components/Order/shared/Details/PaymentMethod/paymentMethods.container";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type OrderDetailsComponentProps = {
    creationDate: string;
    payments: Array<Payment>;
};

const OrderDetailsComponent = ({
    creationDate,
    payments
}: OrderDetailsComponentProps) => {
    const { t } = useGranite();

    return (
        <>
            <div className="mb-4">
                <h4>{t("orderOverview.title.orderDate")}</h4>
                <p>{creationDate}</p>
            </div>
            <div className="mb-4">
                <h4>{t("orderOverview.title.paymentMethod")}</h4>
                <PaymentMethods
                    payments={payments}
                    showAmount={false}
                />
            </div>
        </>
    );
};

export { OrderDetailsComponent };
